import {SnackbarService} from './snackbar.service';

// This is essentially DIY dependency injection
export class ServiceContainer {
    private static _snackbar: SnackbarService;

    static get snackbar(): SnackbarService {
        if (!this._snackbar) {
            this._snackbar = new SnackbarService();
        }
        return this._snackbar;
    }
}